import { render } from "./FormRelManyBlock.vue?vue&type=template&id=e6db3e2e"
import script from "./FormRelManyBlock.vue?vue&type=script&lang=js"
export * from "./FormRelManyBlock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelManyBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e6db3e2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e6db3e2e', __exports__)) {
    console.log('reload')
    api.reload('e6db3e2e', __exports__)
  }
  
  module.hot.accept("./FormRelManyBlock.vue?vue&type=template&id=e6db3e2e", () => {
    console.log('re-render')
    api.rerender('e6db3e2e', render)
  })

}


export default __exports__